import React, { FC, memo } from 'react'

import { Routes } from 'common/constants'
import { useNavigate } from 'react-router-dom'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { InterSvgIcon } from 'components'
import { map } from 'lodash'
import { Button } from 'common/styles/layouts'

import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'
// import IcClock from '@interco/icons/core/action-navigation/ic_clock'
import { Text } from '@interco/inter-ui/components/Text'

import {
  BottomSheetContent,
  BottomSheetTextSectionContainer,
  PendingSvgWrapper,
  ReportCardContainerBulletPoints,
} from './styles'

export type ReportRequestConfirmationBottomSheetProps = {
  onConfirm: () => void
  onCancel: () => void
  isRequestLoading: boolean
  isRequestSuccess: boolean
  isRequestError: boolean
  bulletPoints?: {
    one: string
    two: string
    three: string
  }
}

export const ReportRequestConfirmationBottomSheet: FC<ReportRequestConfirmationBottomSheetProps> =
  memo(
    ({ isRequestLoading, isRequestSuccess, isRequestError, bulletPoints, onCancel, onConfirm }) => {
      const { privacyCenterContent } = useAppContext()

      const navigate = useNavigate()

      const isActive = privacyCenterContent?.components?.confirmRequestReportBottomsheet?.isActive

      const content = privacyCenterContent?.components?.confirmRequestReportBottomsheet?.content

      if (!isActive || !content) return null

      const { title, details, confirmButton, cancelButton, icon } = content

      if (isRequestSuccess)
        navigate(Routes.SUCCESS_REPORT_REQUESTED, {
          state: { backRoute: Routes.YOUR_PERSONAL_DATA },
        })

      if (isRequestError)
        navigate(Routes.UNAVAILABLE_SERVICE, {
          state: { goTo: Routes.YOUR_PERSONAL_DATA },
        })

      return (
        <BottomSheet onClose={onCancel}>
          <BottomSheetContent>
            <PendingSvgWrapper>
              {icon && (
                <InterSvgIcon iconRef={icon} height={36} width={36} color="var(--alert100)" />
              )}
            </PendingSvgWrapper>
            <BottomSheetTextSectionContainer>
              <Text variant="headline-h3" color="typography" semiBold as="p">
                {title}
              </Text>
              <Text variant="body-3" color="typography" as="p">
                {details}
              </Text>
              {bulletPoints && (
                <ReportCardContainerBulletPoints>
                  {map(bulletPoints, (bulletPoint) => (
                    <li key={bulletPoint}>
                      <Text variant="body-3" color="typography" colorWeight={400} fontWeight={400}>
                        {bulletPoint}
                      </Text>
                    </li>
                  ))}
                </ReportCardContainerBulletPoints>
              )}
            </BottomSheetTextSectionContainer>

            <Button variant="primary" fullWidth onClick={onConfirm} isLoading={isRequestLoading}>
              {confirmButton}
            </Button>
            <Button variant="secondary" fullWidth onClick={onCancel}>
              {cancelButton}
            </Button>
          </BottomSheetContent>
        </BottomSheet>
      )
    },
  )
